"use strict";
// import type {TypeOf} from "suretype"
// import {compile, v} from "suretype"
Object.defineProperty(exports, "__esModule", { value: true });
